/** Read compatibility for historical messages; response policy is owned by the backend. */
export function stripNovaResponseGuidance(content: string): string {
  const open = '[APEX NOVA RESPONSE STYLE v1]\n';
  const close = '\n[END APEX NOVA RESPONSE STYLE]\n\n';
  if (!content.startsWith(open)) return content;
  const end = content.indexOf(close, open.length);
  return end >= 0 && end < 6000 ? content.slice(end + close.length) : content;
}

export type NovaResponseState = 'answer' | 'streaming' | 'empty' | 'incomplete' | 'error' | 'partial';

/** Deliberately narrow: detect empty promises, never infer that a tool succeeded. */
export function novaResponseState(content: string, streaming = false, failed = false, request = ''): NovaResponseState {
  if (failed) return content.trim() ? 'partial' : 'error';
  if (streaming) return 'streaming';
  if (!content.trim()) return 'empty';
  if (/\b(?:what can (?:you|nova)|your capabilities|do you support|are you able to|can you generally)\b/i.test(request)) return 'answer';
  const text = content.replace(/[*_]/g, '').trim();
  return /^(?:(?:sure|yes|absolutely|of course|okay|ok)[!,.\s—–-]+)?(?:i can|i will|i'll|let me)\s+(?:take a look|look into|review|check|analy[sz]e|summari[sz]e|list|find|search|open|update|create|delete|remove)\b[^\n.!?]*[.!]?$/i.test(text)
    && !/\b(?:but|cannot|can't|unable|need|missing|failed|because|if|once|only)\b/i.test(text)
    ? 'incomplete' : 'answer';
}

export function novaResponseNotice(state: NovaResponseState): string {
  switch (state) {
    case 'incomplete': return 'NovaAI returned an acknowledgement without a result. The requested work is not confirmed as completed.';
    case 'empty': return 'NovaAI returned no answer. If this request could change data, check its status before trying again.';
    case 'error': return 'NovaAI could not finish this response. If this request could change data, check its status before trying again.';
    case 'partial': return 'This response was interrupted and may be incomplete. Any requested changes are not confirmed.';
    default: return '';
  }
}
